import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useState } from "react";
import Loader from "../../UiComponent/Loader";
import Toast from "../../UiComponent/Toast/Toast";
import { color_theme } from "../../utils/constants";
import apiServices from "../../services/RequestHandler";

const StripeCheckout = (props: any) => {
  const {
    handleOtpSend,
    handleCloseDialog,
    handleSubmitOrder,
    handleGetCardDetails,
  } = props;
  const [activity, setActivity] = React.useState(false);
  const [nameOncard, setNameOncard] = useState("");

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    if (!stripe || !elements) {
      Toast.Error("Something went wrong!")
      return;
    }
    if (!handleOtpSend && !handleSubmitOrder) {
      const result = await stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements,
        confirmParams: {
          return_url: "https://www.frank.fr/",
          payment_method_data: {
            billing_details: {
              name: nameOncard,
            },
          },
        },
        redirect: "if_required",
      });
      if (result.error) {
        let error = result.error;
        if (error?.code?.toLowerCase() == "canceled") {
          Toast.Error(
            `Vous avez annulé le processus d'autorisation de paiement.`
          );
        } else if (error?.message?.toLowerCase() == "your card has expired") {
          Toast.Error(error?.message ?? "");
          // Alert.alert('', error?.localizedMessage);
        } else if (
          error.type === "api_error" ||
          error.type === "invalid_request_error" ||
          error.type === "api_connection_error" ||
          error.type === "authentication_error" ||
          error.type === "idempotency_error" ||
          !error.type
        ) {
          if (
            error.message ==
            "We are unable to authenticate your payment method. Please choose a different payment method and try again."
          ) {
            Toast.Error(error?.message);
          } else {
            console.log(error);
            Toast.Error(
              `Nous vous prions de nous excuser, mais nous n'avons pas pu traiter votre paiement pour le moment. Veuillez réessayer plus tard. Si l'erreur persiste, veuillez contacter l'équipe de Frank.`
            );
          }
        } else {
          Toast.Error(error?.message);
        }
        // Show error to your customer (for example, payment details incomplete)
      } else {
        Toast.showSuccess("Banque ajoutée avec succès");
        handleCloseDialog();
        handleGetCardDetails();
      }
    }
    if (handleOtpSend) {
      setActivity(true);
      const result = await stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements,
        confirmParams: {
          return_url: "https://dev.frank.fr//",
        },
        redirect: "if_required",
      });
      if (result.error) {
          let error = result.error;
        if (error?.code?.toLowerCase() == "canceled") {
          Toast.Error(
            `Vous avez annulé le processus d'autorisation de paiement.`
          );
        } else if (error?.message?.toLowerCase() == "your card has expired") {
          Toast.Error(error?.message ?? "");
          // Alert.alert('', error?.localizedMessage);
        } else if (
          error.type === "api_error" ||
          error.type === "invalid_request_error" ||
          error.type === "api_connection_error" ||
          error.type === "authentication_error" ||
          error.type === "idempotency_error" ||
          !error.type
        ) {
          if (
            error.message ==
            "We are unable to authenticate your payment method. Please choose a different payment method and try again."
          ) {
            Toast.Error(error?.message);
          } else {
            console.log(error);
            Toast.Error(
              `Nous vous prions de nous excuser, mais nous n'avons pas pu traiter votre paiement pour le moment. Veuillez réessayer plus tard. Si l'erreur persiste, veuillez contacter l'équipe de Frank.`
            );
          }
        } else {
          Toast.Error(error?.message);
        }
        // Show error to your customer (for example, payment details incomplete)
      } else {
        // Toast.showSuccess("Payment Succesfull");
        handleOtpSend();
      }

      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      setActivity(false);
    }
    // if (handleSubmitOrder) {
    //   setActivity(true);
    //   const result = await stripe.confirmPayment({
    //     //`Elements` instance that was used to create the Payment Element
    //     elements,
    //     confirmParams: {
    //       return_url: "https://www.v2internal.frankme.com/",
    //     },
    //     redirect: "if_required",
    //   });
    //   setActivity(false);

    //   if (result.error) {
    //     // Show error to your customer (for example, payment details incomplete)
    //     setActivity(false);
    //   } else {
    //     setActivity(false);

    //     handleSubmitOrder();
    //   }
    // }
    setActivity(false);
  };

  return (
    <>
      <Loader loading={activity} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px 0px",
        }}
      >
        {/* { !handleOtpSend && !handleSubmitOrder ? <div style={{ marginBottom: 10 ,display:'none'}}>
            <label htmlFor="" >Name on Card</label>
            <div
              style={{
                paddingLeft: 14,
                paddingRight: 14,
                height: 43,
                borderRadius: 4,
                background: "white",
                display: "flex",
                alignItems: "center",
                marginTop: 5,

                transition:
                  "background 0.15s ease, border 0.15s ease, box-shadow 0.15s ease, color 0.15s ease",
                border: "1px solid #e6e6e6",
                boxShadow:
                  "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02)",
              }}
            >
              <input
                placeholder="John Doe."
                style={{
                  outline: "none",
                  border: "none",
                  fontSize: 16,
                  width: "100%",
                }}
                id="name_on_card"
                value={nameOncard}
                onChange={(e) => setNameOncard(e.target.value)}
              />
            </div>
            
          </div> : null } */}
        <PaymentElement />

        <button
          onClick={handleSubmit}
          disabled={!stripe}
          style={{
            padding: "12px 24px",
            backgroundColor: color_theme.main_orange,
            background: color_theme.main_orange,
            borderRadius: 12,
            placeContent: "center",
            display: "flex",
            placeItems: "center",
            cursor: "pointer",

            fontSize: 16,
            fontFamily: "montserrat-Bold",
            lineHeight: "18px",
            color: color_theme.white,
            border: "none",
            marginTop: 12,
          }}
        >
          Enregistrer
        </button>
      </div>
    </>
  );
};

export default StripeCheckout;
